// src/components/modals/DuplicateModal.jsx
// Modal shown when user tries to add existing plate

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Camera, X } from 'lucide-react';

export const DuplicateModal = ({ plate, existingPost, onClose }) => {
  const navigate = useNavigate();

  const handleGoToPost = () => {
    // Navigate with hash and query params for auto-scroll + highlight
    navigate(`/pojazd/${existingPost.id}?highlight=addPhoto#timeline`);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl animate-fadeIn">
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white p-6 rounded-t-2xl relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
          
          <div className="text-center">
            <AlertTriangle size={48} className="mx-auto mb-3 animate-bounce" />
            <h2 className="text-2xl font-black">
              TA TABLICA JUŻ ISTNIEJE!
            </h2>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Plate info */}
          <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-4 mb-4">
            <div className="font-black text-2xl text-center mb-2">
              {plate}
            </div>
            <div className="text-sm text-gray-600 text-center">
              została już zgłoszona przez innego użytkownika
            </div>
          </div>

          {/* Existing post preview */}
          {existingPost && (
            <div className="bg-gray-50 rounded-xl p-4 mb-4">
              <div className="text-sm font-bold text-gray-700 mb-2">
                Istniejące zgłoszenie:
              </div>
              <div className="flex gap-3">
                {/* Thumbnail */}
                {(existingPost.imageUrl || existingPost.images?.[0]) && (
                  <img 
                    src={existingPost.imageUrl || existingPost.images[0]}
                    alt={plate}
                    className="w-20 h-20 object-cover rounded-lg"
                  />
                )}
                
                {/* Info */}
                <div className="flex-1 text-sm">
                  <div className="font-bold text-gray-900">
                    {existingPost.brand || 'Nieznana marka'}
                  </div>
                  <div className="text-gray-600">
                    {existingPost.locationName || existingPost.location || 'Lokalizacja nieznana'}
                  </div>
                  <div className="text-gray-500 text-xs mt-1">
                    📸 {existingPost.commentCount || 0} komentarzy
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Instructions */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6">
            <div className="flex items-start gap-3">
              <Camera size={20} className="text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="text-sm text-gray-700">
                <span className="font-bold">Możesz dodać swoje zdjęcie</span> w timeline istniejącego pojazdu!
                <div className="text-xs text-gray-500 mt-1">
                  Zostaniesz przekierowany do pojazdu, gdzie możesz dodać zdjęcie używając przycisku w timeline.
                </div>
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleGoToPost}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg flex items-center justify-center gap-2"
            >
              <Camera size={20} />
              Zobacz pojazd i dodaj zdjęcie
            </button>
            
            <button
              onClick={onClose}
              className="px-6 py-3 bg-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-300 transition-all"
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
